const types = {
  like: "5e2ccd5a-11b5-4dd4-a5a7-a710465bfebe",
  dislike: "4c835ad1-4750-4c13-be07-48b09a643010",
  loved: "c84e45fa-e20c-4f1a-9950-504009c31dc2",
};

export default types;
